<script lang="ts">
    import type { OpenHoursType } from './types';
    import { open_hours_defaults } from './types';
    import { _ } from 'svelte-i18n';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';

    export let openHours: OpenHoursType = open_hours_defaults;
    export let onChange: () => void = () => {};

    let daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    let daysOfWeekShort = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

    // function getHoursWithHalfHourPrecision(hours: number): string[] {
    //     const result: string[] = [];
    //     for (let i = 0; i < hours * 2; i++) {
    //         const hour = ('0' + Math.floor(i / 2)).slice(-2);
    //         const minute = i % 2 === 0 ? '00' : '30';
    //         result.push(`${hour}:${minute}`);
    //     }
    //     return result;
    // }

    function getHoursWithHalfHourPrecision(hours: number): string[] {
        const result: string[] = [];
        for (let i = 0; i < hours * 6; i++) {
            const hour = ('0' + Math.floor(i / 6)).slice(-2);
            const minute = (i % 6) * 10 < 10 ? '0' + (i % 6) * 10 : (i % 6) * 10;
            result.push(`${hour}:${minute}`);
        }
        return result;
    }

    function calcSumHoursFromOpenHours(openHours: {
        open: string | false;
        close: string | false;
    }): string {
        if (!openHours.open || !openHours.close) {
            return '';
        }
        const open = openHours.open.split(':');
        const close = openHours.close.split(':');
        const openMinutes = parseInt(open[0]) * 60 + parseInt(open[1]);
        const closeMinutes = parseInt(close[0]) * 60 + parseInt(close[1]);
        const minutes = closeMinutes - openMinutes;
        const hours = Math.floor(minutes / 60);
        const minutesRest = minutes % 60;
        if (hours <= 0) {
            return '-';
        }
        if (minutesRest === 0) {
            return `${hours} h`;
        }
        return `${hours} h ${minutesRest < 10 ? '0' : ''}${minutesRest}`;
    }

    let disabled: { [x: string]: boolean } = {};
    for (let d of daysOfWeek) {
        disabled[d] = !openHours[d].open || !openHours[d].close;
    }

    function setupDefaultsOnChange(dayOfWeek: string) {
        if (disabled[dayOfWeek]) {
            openHours[dayOfWeek].open = '';
            openHours[dayOfWeek].close = '';
        } else {
            let dayidx = daysOfWeek.indexOf(dayOfWeek);
            do {
                dayidx--;
                if (dayidx >= 0 && !disabled[daysOfWeek[dayidx]]) {
                    openHours[dayOfWeek].open = openHours[daysOfWeek[dayidx]].open;
                    openHours[dayOfWeek].close = openHours[daysOfWeek[dayidx]].close;
                }
            } while (dayidx > 0 && disabled[daysOfWeek[dayidx]]);
        }
        if (!disabled[dayOfWeek] && openHours[dayOfWeek].open === '') {
            openHours[dayOfWeek].open = '08:00';
        }
        if (!disabled[dayOfWeek] && openHours[dayOfWeek].close === '') {
            openHours[dayOfWeek].close = '16:00';
        }
    }
</script>

<div>
    <div class="grid-container">
        {#each daysOfWeek as dayOfWeek, index (dayOfWeek)}
            <div class="select-open-hours-day">
                <div
                    class="day"
                    on:click={() => {
                        disabled[dayOfWeek] = !disabled[dayOfWeek];
                        setupDefaultsOnChange(dayOfWeek);
                        onChange();
                    }}
                >
                    <Checkbox label="" checked={!disabled[dayOfWeek]} onChange={() => {}} />
                    <label for="open_hours_{dayOfWeek}">{$_(daysOfWeekShort[index])}</label>
                </div>
                <div class="hour-from">
                    <select
                        class="input-small"
                        bind:value={openHours[dayOfWeek].open}
                        disabled={disabled[dayOfWeek]}
                        on:change={onChange}
                    >
                        <option value={openHours[dayOfWeek].open}
                            >{openHours[dayOfWeek].open}</option
                        >
                        {#each getHoursWithHalfHourPrecision(24) as hour}
                            <option value={hour}>{hour.replace(/^0/, '')}</option>
                        {/each}
                    </select>
                </div>
                <div class="hour-to">
                    <select
                        class="input-small"
                        bind:value={openHours[dayOfWeek].close}
                        disabled={disabled[dayOfWeek]}
                        on:change={onChange}
                    >
                        <option value={openHours[dayOfWeek].close}
                            >{openHours[dayOfWeek].close}</option
                        >
                        {#each getHoursWithHalfHourPrecision(24) as hour}
                            <option value={hour}>{hour.replace(/^0/, '')}</option>
                        {/each}
                    </select>
                </div>
                <div class="total-hours">{calcSumHoursFromOpenHours(openHours[dayOfWeek])}</div>
            </div>
        {/each}
    </div>
</div>

<style>
    .grid-container {
        display: flex;
        flex-direction: row;
        column-gap: 10px;
        flex-wrap: wrap;
        row-gap: 10px;
    }
    .grid-container .day {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        justify-content: center;
        column-gap: 4px;
        /*padding: 3px 0;*/
    }
    .grid-container .total-hours {
        /*color: var(--automapa-grey-dark);*/
        color: #000;
        display: flex;
        justify-content: center;
        /*padding: 5px 0;*/
        font-weight: 600;
        opacity: 0.6;
        /*font-size: var(--list-element-data-font-size);*/
        font-size: 14px;
    }
    .select-open-hours-day {
        display: flex;
        flex-direction: column;
        row-gap: 5px;
    }
    /*.grid-container {*/
    /*    display: grid;*/
    /*    grid-template-columns: 100px 30px 60px 20px 60px 80px;*/
    /*    box-sizing: border-box;*/
    /*    grid-gap: 0;*/
    /*    align-items: center;*/
    /*}*/
    .input-small {
        border-radius: var(--input-small-border-radius);
        background-color: white;
        width: 68px;
        padding: var(--input-small-padding);
        border: var(--input-small-border);
        color: var(--input-small-color);
    }
</style>
